import styled from "styled-components";
import type { StyledIconBoxProps } from "./IconBox.types.js";

export const StyledIconBox = styled.div<StyledIconBoxProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    width: fit-content;
    height: fit-content;
    background: ${({ backgroundColor }) => backgroundColor};
    padding: ${({ padding, theme }) => padding ?? theme.spacing[12]};
    border-radius: ${({ shape, theme }) => (shape === "round" ? theme.radius.round : theme.radius.xs)};
`;
